import { clamp } from './math'
import * as Lightbox from './Lightbox'

// The exporting class.

addEventListener('DOMContentLoaded', () => {
	const elements = document.getElementsByClassName('image-slider')
	
	for (let a = 0; a < elements.length; a++) {
		Slider.sliderList.push(new Slider(elements[a]))
	}
})

export default class Slider {
	// Keep a list of *all* sliders.
	static sliderList = []
	
	constructor(element) {
		this.element = element

		this.currentIndex = 0

		this.images = this.element.querySelectorAll('picture')
		this.dots = this.element.querySelectorAll('.dots .dot')

		if (this.images.length <= 1) {
			return this
		}

		// Steppers.
		this.element.querySelector('.stepper.next')?.addEventListener('click', (event) => {
			event.preventDefault()
			this.setIndex(this.currentIndex + 1)
		}, true)

		this.element.querySelector('.stepper.previous')?.addEventListener('click', (event) => {
			event.preventDefault()
			this.setIndex(this.currentIndex - 1)
		}, true)

		// Fullscreen/lightbox mode
		this.element.querySelector('.fullscreen')?.addEventListener('click', (event) => {
			this.onImageClick()
		})

		for (let a = 0; a < this.dots.length; a++) {
			const index = a
			this.dots[a].addEventListener('click', () => this.setIndex(index))
		}

		// Force initialization.
		this.setIndex()
	}

	setIndex(index = 0) {
		index = clamp(index, 0, this.images.length - 1)

		this.element.classList[index == 0 ? 'add' : 'remove']('first')
		this.element.classList[index == (this.images.length - 1) ? 'add' : 'remove']('last')

		if (this.images.length > 0) {
			for (let a = 0; a < this.images.length; a++) {
				const offset = Math.sign(a - index)
				this.images[a].className = `offset${offset}`
				this.dots[a].classList[a === index ? 'add' : 'remove']('active')
			}
		}

		this.currentIndex = index
	}

	onImageClick() {
		const images = []
		for (let a = 0; a < this.images.length; a++) {
			images.push({
				src: this.images[a].dataset.lbImage,
				title: this.images[a].lbTitle,
			})
		}

		Lightbox.open(images, this.currentIndex)
	}
}